"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _exports$MEDIA_URL_BA, _exports$VIEW_ETHERSC;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZORA_SITE_URL_BASE = exports.VIEW_ETHERSCAN_URL_BASE_BY_NETWORK = exports.MEDIA_URL_BASE_BY_NETWORK = void 0;

var nft_hooks_1 = require("@zoralabs/nft-hooks");

exports.MEDIA_URL_BASE_BY_NETWORK = (_exports$MEDIA_URL_BA = {}, _defineProperty(_exports$MEDIA_URL_BA, nft_hooks_1.Networks.MAINNET, "https://zora.co/"), _defineProperty(_exports$MEDIA_URL_BA, nft_hooks_1.Networks.RINKEBY, null), _exports$MEDIA_URL_BA);
exports.VIEW_ETHERSCAN_URL_BASE_BY_NETWORK = (_exports$VIEW_ETHERSC = {}, _defineProperty(_exports$VIEW_ETHERSC, nft_hooks_1.Networks.MAINNET, "https://etherscan.io/token/"), _defineProperty(_exports$VIEW_ETHERSC, nft_hooks_1.Networks.RINKEBY, "https://rinkeby.etherscan.io/token/"), _exports$VIEW_ETHERSC);
exports.ZORA_SITE_URL_BASE = "https://zora.co";